import { Icon } from '@natera/material/lib/icon'
import React from 'react'
import {
  IconButton,
  LocalIcon,
  OptiReading,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ScrollArea,
  Text,
} from '~/shared/ui'
import { useReleaseNotes } from '../api'
import { useReleaseNotesSelectors } from '../model'
import { ReleaseNoteItem } from './release-note-item/release-note-item'

function ReleaseNotes() {
  const { isPopupOpen, setIsPopupOpen, lastReadReleaseNoteVersion } = useReleaseNotesSelectors()
  const {
    data: { data: releaseNotes = [] },
  } = useReleaseNotes()

  const sortedReleaseNotes = releaseNotes.sort((a, b) => b.Version.localeCompare(a.Version))
  const hasUnreadReleaseNotes = sortedReleaseNotes[0]?.Version !== lastReadReleaseNoteVersion

  if (releaseNotes.length === 0) {
    return null
  }

  return (
    <Popover
      open={isPopupOpen}
      onOpenChange={setIsPopupOpen}
    >
      <div className="relative">
        <PopoverTrigger asChild>
          <IconButton materialIcon="release_alert"></IconButton>
        </PopoverTrigger>
        {hasUnreadReleaseNotes && (
          <span className="bg-primary-main absolute top-2 left-8 size-2 rounded-full" />
        )}
      </div>
      <PopoverContent
        className="flex h-[calc(min(700px,100dvh-90px))] w-[460px] flex-col shadow-[0px_3px_6px_0px_rgba(0,0,0,0.04),0px_7px_24px_0px_rgba(0,0,0,0.19)]"
        align="end"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="border-divider flex items-center justify-between border-b px-6 py-4">
          <div className="flex items-center gap-6">
            <OptiReading width={32} />
            <Text appearance="H6">Release Notes</Text>
          </div>
          <IconButton
            size="medium"
            container="small"
            materialIcon="close"
            onClick={() => setIsPopupOpen(false)}
          />
        </div>
        <ScrollArea className="flex-1">
          <div className="flex flex-col gap-3 px-6 py-4">
            {sortedReleaseNotes.map((releaseNote, index) => (
              <ReleaseNoteItem
                key={releaseNote.id}
                defaultOpen={index === 0}
                title={releaseNote.Title}
                version={releaseNote.Version}
                body={releaseNote.Body}
                isFirst={index === 0}
                releaseDate={releaseNote.ReleaseDate}
              />
            ))}
          </div>
        </ScrollArea>
        <div className="flex flex-col gap-2.5 px-6 py-6 pt-4">
          <Text appearance="OVERLINE">Need Help or Want to Learn More? </Text>
          <div className="grid grid-cols-2 gap-x-10 gap-y-3">
            <div className="flex items-center gap-2">
              <Icon
                className="text-info-main shrink-0"
                children="help"
                fill
              />
              <a
                className="text-text-link"
                href="https://sites.google.com/natera.com/rcmacademy/our-innovation/optistream-training-hub"
                target="_blank"
                rel="noopener noreferrer"
              >
                Training Hub
              </a>
            </div>
            <div className="flex items-center gap-2">
              <LocalIcon
                className="shrink-0 p-[3px]"
                name="gChat"
                size="18"
              />
              <a
                className="text-text-link"
                href="https://chat.google.com/room/AAAAGiAvlXI/uaX5FzjYnRs/uaX5FzjYnRs"
                target="_blank"
                rel="noopener noreferrer"
              >
                GChat
              </a>
            </div>
            <div className="flex items-center gap-2">
              <LocalIcon
                className="shrink-0 p-[3px]"
                name="slack"
                size="18"
              />
              <a
                className="text-text-link"
                href="slack://channel?team=T06C6MH5Y&id=C08S1U4SJJD"
                target="_blank"
                rel="noopener noreferrer"
              >
                Slack
              </a>
            </div>
            <div className="flex items-center gap-2">
              <LocalIcon
                className="shrink-0 p-[3px]"
                name="confluence"
                size="18"
              />
              <a
                className="text-text-link"
                href="https://go.confluence.natera.com/wiki/spaces/UEG/pages/252022849"
                target="_blank"
                rel="noopener noreferrer"
              >
                Confluence
              </a>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export function ReleaseNotesSuspended() {
  return (
    <React.Suspense>
      <ReleaseNotes />
    </React.Suspense>
  )
}
